import { AlertTriangle } from "lucide-react";

export function BudgetAlertsBanner({ alerts }: { alerts: string[] }) {
  if (!alerts.length) return null;

  return (
    <div className="grid gap-2">
      {alerts.map((alert) => (
        <div
          key={alert}
          className="flex items-center gap-3 rounded-lg border border-amber-200/50 bg-amber-50/50 px-4 py-3 text-sm text-amber-900 dark:border-amber-900/50 dark:bg-amber-900/20 dark:text-amber-200"
        >
          <AlertTriangle className="h-4 w-4 text-amber-600 dark:text-amber-400" />
          <span>{alert}</span>
        </div>
      ))}
    </div>
  );
}
